export default __webpack_public_path__ + "static/Cart-Gear-8f318f35919445e6224d3cdf1d3bfb0b.jpg";